import { Component, forwardRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material';

@Component({
  selector: 'app-dms-document-type',
  templateUrl: './dms-document-type.component.html',
  styleUrls: ['./dms-document-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DmsDocumentTypeComponent),
      multi: true,
    },
  ],
})
export class DmsDocumentTypeComponent {
  @ViewChild('select', { static: true }) select: MatSelect;
  @Input()
  public dmsDocumentTypes: string[];

  constructor() {}

  writeValue(obj: any): void {
    this.select.value = obj;
  }
  registerOnChange(fn: any): void {
    this.select.registerOnChange(fn);
  }
  registerOnTouched(fn: any): void {
    this.select.registerOnTouched(fn);
  }
  setDisabledState?(isDisabled: boolean): void {
    this.select.disabled = isDisabled;
  }
}
